<template>
	<div>
		<loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="true"></loading>
		<h5><a :href="'/inscricaos/visualizar/avaliacoes/' + this.rec.inscricao_id" target='_blank'>Resultado</a></h5>
		<br>
		<h5>Itens do Recurso</h5>
		<div v-for='(recItem, indexRec) in recItens' class="row">
			<div class="input-field col s12 m9 l9 x9">
				<select v-model="recItem.aval_item_id + '_' + recItem.planos_de_trabalho_id" :name="'select_' + indexRec" class="browser-default select_sec" @change="adicionaItem($event);" :disabled='rec.id'>
					<option selected disabled value="0">Escolha o item</option>
					<option v-for="item in itens" :hidden="!itemNovo(item, indexRec)" v-bind:value="item.id + '_' + item.plano_id">{{ item.nome }}</option>
				</select>
			</div>
			<div class="input-field col s12 m2 l2 x2">
				<select v-model="recItem.avaliacao_id" class="browser-default select_sec" :disabled='rec.id'>
					<option selected disabled value="0">Avaliador</option>
					<option v-for="(avaliacao, indexAval) in avals" v-bind:value="avaliacao.id" :disabled='avaliacao.impedido || avaliacao.invalido'>Avaliador {{ indexAval + 1 }}</option>
				</select>
			</div>
			<div class="col s12 m1 l1 x1" v-if="!rec.id">
				<a class="btn-floating btn-large red waves-effect waves-light"
				   title="Excluir"
				   @click="removeItem(indexRec)"><i class="material-icons left">delete</i>Excluir</a>
			</div>
		</div>
		
		<div class="row" v-if="!rec.id">
			<div class="col s12">
				<button type="button"
						class="btn waves-effect waves-light light-blue lighten-1"
						@click.prevent="adicionaNovoItem()">
					<i class="material-icons left">add</i>
					Adicionar
				</button>
			</div>
		</div>
		<br><br>
		
		<div class="row">
			<div class="input-field col s12 m12 l12 x12">
				<textarea name="texto" :readonly='rec.id' id="texto" v-model="rec.texto" class="materialize-textarea" :maxlength="caracteres" :data-length="caracteres"></textarea>
				<label for="texto" class='active'>Justificativa</label>
			</div>
		</div>
		<center>
			<div class="row" v-if="!rec.id">
				
				<div class="input-field col s6 m6 l6 xl6">
					<button :disabled='!recItens.length || !rec.texto || !rec.texto.trim().length' type="button" class="btn" @click.prevent="enviar">
						<i class="material-icons left">save</i>Enviar
					</button>
				</div>
				<div class="input-field col s6 m6 l6 xl6">
					<button type="reset" class="btn indigo">
						<i class="material-icons right">clear</i>Limpar
					</button>
				</div>
			</div>
		</center>
	</div>
</template>

<script>
	import Loading from 'vue-loading-overlay';
	import 'vue-loading-overlay/dist/vue-loading.css';
    
	export default {
		name: "VueRecursoForm",
		components: {Loading},
		props: [
			'recurso',
			'caracteres',
			'aval_itens',
			'avaliacoes', 
			'planos_trabalho'
		],
		data () {
			return {
				rec: JSON.parse(this.recurso),
				itens: JSON.parse(this.aval_itens),
				avals: JSON.parse(this.avaliacoes),
				planos: JSON.parse(this.planos_trabalho),
				recItens: JSON.parse(this.recurso).recurso_items,
				loading: false
			}
		},
		methods: {
			adicionaNovoItem() {
				this.recItens.push({avaliacao_id: 0, aval_item_id: 0, planos_de_trabalho_id: null});
			},
			adicionaItem(evento) {
				var select = evento.target,
					selName = select.name,
					selItem = this.itens[select.selectedIndex - 1],
					recItem = this.recItens[parseInt(selName.substring(selName.indexOf('_') + 1, selName.length))];
				
				recItem.planos_de_trabalho_id = selItem.plano_id;
				recItem.aval_item_id = selItem.id;
			},
			removeItem(index) {
				this.recItens.splice(index, 1);
			},
			itemNovo(item, indexRec) {
				var recItens = this.recItens,
					i = recItens.length;	
			
				while (--i >= 0)
					if (indexRec != i && (item.plano_id == recItens[i].planos_de_trabalho_id && item.id == recItens[i].aval_item_id))
						return false;
					
				return true;
			},
			async enviar() {
				var confirmaEnvio = true;

				await Swal.fire({
					title: 'Tem certeza que deseja submeter o recurso?',
					text: "Após a submissão não será mais possível editá-lo!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Sim, pode enviar!',
					cancelButtonText: 'Cancelar.'
				}).then((result) => {
					confirmaEnvio = result.isConfirmed
				})

				if (confirmaEnvio) {
					var recItens = this.recItens,
						i = recItens.length;
				
					if (!recItens.length) {
						Swal.fire({ title: 'Ação inválida!', text: 'É necessário informar ao menos um item para pedir o recurso!', icon: 'error'});
						return;
					}
					
					if (!this.rec.texto || !this.rec.texto.trim().length) {
						Swal.fire({ title: 'Ação inválida!', text: 'É necessário informar uma justificativa para pedir o recurso!', icon: 'error'});
						return;
					}
				
					while (--i >= 0) 
						if (!recItens[i].avaliacao_id || !recItens[i].aval_item_id) { 
							Swal.fire({ title: 'Ação inválida!', text: 'É necessário preencher todos os campos de cada item do recurso!', icon: 'error'});
							return;
						}
						
					this.loading = true;

					await this.$http.post('/api/recursos/' + this.rec.inscricao_id, {
						recurso: this.rec,
						itens: this.recItens
					}
					).then(response => {
						window.location.href = `/inscricaos/?msg=${response.body.msg}`
					}, error => {
						Swal.fire({ title: 'Ocorreu um erro!', text: error.body.msg, footer: error.body.exception, icon: 'error'});
					})

					this.loading = false;
				}
			}
		}, 
		mounted() {
			var itens = this.itens,
				planos = this.planos,
				numPlanos = planos.length,
				numItens = itens.length,
				item,
				i = -1,
				j;
		
			while (++i < numItens) {
				if (itens[i].campo_referente_na_inscricao == 'planos_de_trabalho') {
					j = 0;
					while (++j <= numPlanos) {
						item = structuredClone(itens[i]);
						item.nome = 'Plano ' + j + '- ' + item.nome;
						item.plano_id = planos[j - 1].id;
						itens.push(item);
						
					}
					itens.splice(i--, 1);
					numItens--;
				} else
					itens[i].plano_id = null;
			
			}
			$("#texto").characterCounter();
		}
	}
</script>